var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSignOut = function SvgSignOut(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40192 3.5C3 4.19615 3 5.13077 3 7L3 17C3 18.8692 3 19.8038 3.40192 20.5C3.66523 20.9561 4.04394 21.3348 4.5 21.5981C5.19615 22 6.13077 22 8 22C9.86923 22 10.8038 22 11.5 21.5981C11.9561 21.3348 12.3348 20.9561 12.5981 20.5C13 19.8038 13 18.8692 13 17V12.7502L19.1895 12.7502L16.4699 15.4698C16.177 15.7627 16.177 16.2376 16.4699 16.5305C16.7627 16.8234 17.2376 16.8234 17.5305 16.5305L21.5305 12.5305C21.8234 12.2376 21.8234 11.7627 21.5305 11.4698L17.5305 7.46982C17.2376 7.17693 16.7627 7.17693 16.4699 7.46982C16.177 7.76272 16.177 8.23759 16.4699 8.53048L19.1895 11.2502L13 11.2502L13 7C13 5.13077 13 4.19615 12.5981 3.5C12.3348 3.04394 11.9561 2.66523 11.5 2.40192C10.8038 2 9.86923 2 8 2C6.13077 2 5.19615 2 4.5 2.40192C4.04394 2.66523 3.66523 3.04394 3.40192 3.5ZM13 11.2502L8.00018 11.2502C7.58597 11.2502 7.25018 11.5859 7.25018 12.0002C7.25018 12.4144 7.58597 12.7502 8.00018 12.7502L13 12.7502V11.2502Z",
    fill: "#22282F"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSignOut);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Sign Out.20bfb5ca02b01167648b68d2e033b2de.svg";